// import numeral from 'numeral'
var numeral = require('numeral')
import {
  timeFormat as d3_timeFormat,
} from 'd3-time-format'
import {utcMonth as d3_timeMonth, utcYear as d3_timeYear, utcWeek as d3_timeWeek } from 'd3-time'

export function formatNumber(value, format, thou, dec) {
  if (numeral.locales['sdv-lib'] === undefined)
    numeral.register('locale', 'sdv-lib', { ...numeral.locales['en'] })
  if (thou === 'none') thou = ''
  numeral.locales['sdv-lib'].delimiters = {
    thousands: thou !== null ? thou : ',',
    decimal: dec !== null ? dec : '.',
  }
  numeral.locale('sdv-lib')
  // chapuzilla porque el numeral asume porcentages en "por 1"
  if (format && format.indexOf('%') >= 0) value = value / 100

  let formattedValue = numeral(value).format(format || '0,0.00')
  return formattedValue
}

// habria qeu mirar que "units" usan los "formats[]" NO!?!?!? ahora asumo YEAR-MONTH y nada mas...
export function getMultiFormat(formats){
  // return  d3_timeFormat(formats[0])
  return (date)=>{
    // console.log(d3_timeYear(date),date)
    let formatYear = d3_timeFormat(formats.find((f)=>f.toLowerCase().indexOf('%y')>=0) || formats[formats.length-1])
    let formatMonth = d3_timeFormat(formats.find((f)=>f.toLowerCase().indexOf('%b')>=0) || formatYear.toString())
    let formatDay = d3_timeFormat(formats.find((f)=>f.toLowerCase().indexOf('%d')>=0) || formatMonth.toString())
    // let formatWeek = d3_timeFormat(formats.find((f)=>f.toLowerCase().indexOf('%w')>=0) || formatDay.toString()) 
    // console.log("formats",[formatDay.toString(),formatMonth.toString(),formatYear.toString()])
    console.log(date,d3_timeMonth(date),d3_timeYear(date))
    return (
      // d3.timeSecond(date) < date ? formatMillisecond
      // : d3.timeMinute(date) < date ? formatSecond
      // : d3.timeHour(date) < date ? formatMinute
      // : d3.timeDay(date) < date ? formatHour
      d3_timeMonth(date) < date ? formatDay
      : d3_timeYear(date) < date ? formatMonth
      : formatYear)(date)
    }
}